import React from 'react';
import { RouteComponentProps } from 'react-router';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { compose } from 'react-apollo';
import GraphQLClient from '@api/graphql/GraphQLClient';
import * as Mutations from '@api/graphql/mutations';
import * as Queries from 'api/graphql/queries';
import DonationForm, { DonationVariablesBeforeSubmit } from '../components/DonationForm';
import { donation, donationVariables, donation_donation } from "@api/graphql/types";
import { ApolloQueryResult } from "apollo-client";
import Notification from 'components/Notification';
import { Loading } from "@components/Loading";
import DataRow from "@components/DataRow";

type Props = InjectedIntlProps & RouteComponentProps<{ id: string }>;

interface State {
    formData: donation_donation | null;
}

class DonationEdit extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            formData: null,
        };
    }

    public componentDidMount() {
        GraphQLClient.query<donation, donationVariables>({
            query: Queries.donation,
            variables: { id: this.props.match.params.id },
        }).then((response: ApolloQueryResult<donation>) => {
            if (response.data && response.data.donation) {
                this.setState({
                    formData: response.data.donation,
                });
            }
        }).catch(() => {
            Notification.error(this.props.intl.formatMessage({ id: 'notification.failed' }));
        });
    }

    private label(id: string): string {
        return this.props.intl.formatMessage({ id: `module.donation.${id}` });
    }

    private onSubmit = (variables: DonationVariablesBeforeSubmit) => {
        return GraphQLClient.mutate({
            mutation: Mutations.updateDonation,
            variables: {
                ...variables,
                id: this.props.match.params.id,
                active: {
                    active_from: variables.active_from,
                    active_to: variables.active_to,
                },
                active_from: undefined,
                active_to: undefined,
                donation_total: undefined,
                round_donated_count: undefined,
                unique_donated_count: undefined,
                not_donated_count: undefined,
                dismissed_count: undefined,
            },
        });
    }

    // TODO: Put first_donation and last_donation into response when backend fix is in
    private renderInfo = (): JSX.Element | null => {
        const { formData } = this.state;
        return formData ? (
            <>
                {["donation_total",
                // "first_donation",
                // "last_donation",
                "round_donated_count", "unique_donated_count", "not_donated_count", "dismissed_count"].map((name: string) => {
                    return (
                        <DataRow key={`${name}`} nameWidth={6} valueWidth={6} data={{ name: this.label(`${name}.title`), value: formData[name] }} />
                    );
                })}
                <hr />
            </>
        ) : null;
    }

    public render() {
        if (!this.state.formData) {
            return <Loading />;
        }

        return (
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">
                        <div className="ibox-title">
                            <h5>{this.props.intl.formatMessage({ id: 'module.donation.update.title' })}</h5>
                        </div>
                        <div className="ibox-content">
                            {this.renderInfo()}
                            <DonationForm
                                formData={this.state.formData}
                                onSubmit={this.onSubmit}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default compose(
    injectIntl,
)(DonationEdit);



// WEBPACK FOOTER //
// ./src/modules/Donation/pages/DonationEdit.tsx